import groq from 'groq';

import { ASSET } from '../common';
import { productHref } from '../product/productHref';
import { PRODUCT_SLUG } from '../product/productSlug';

export const PRODUCT_COMPARISON = groq`
  title,
  products[] {
    "slug": product->{ ${PRODUCT_SLUG} }.slug,
    ${productHref('product->')},
    image { ${ASSET} },
    "formatThumbnail": product->formatThumbnail { ${ASSET} },
    "shopifyImageUrl": product->store.previewImageUrl
  },
  "imageType": coalesce(imageType, "product"),
  table,
  "promoCode": ^.^.promoCode-> {
    "code": code.current,
    message,
  },
  "ctaType": coalesce(ctaType, "none")
`;

export const PRODUCT_COMPARISON_BLOCK = groq`
  _type == 'productComparison' => @ -> {
    ${PRODUCT_COMPARISON}
  }
`;
